import { html, nothing } from "lit";
import {
  FLEET_ARCHITECTURE_ASCII,
  FLEET_CONTROL_RELATIONSHIPS_ASCII,
  FLEET_SYSTEM_CONCEPTS,
} from "../help/fleet-system-concepts.ts";

export type FleetSystemConceptsPanelProps = {
  onOpenGuide?: () => void;
  /** When true, the architecture graph is expanded by default (Help → How it works). */
  diagramOpen?: boolean;
};

export function renderFleetSystemConceptsPanel(props: FleetSystemConceptsPanelProps = {}) {
  return html`
    <div class="fleet-concepts">
      <p class="fleet-concepts__lead muted">
        Config defines who exists and how they connect; workspace files define how they behave; sessions are live
        runs.
      </p>
      <details class="fleet-concepts__diagram" ?open=${props.diagramOpen ?? false}>
        <summary>Gateway topology</summary>
        <pre class="fleet-concepts__ascii mono" aria-label="Fleet gateway topology ASCII diagram">${FLEET_ARCHITECTURE_ASCII}</pre>
        <p class="fleet-concepts__diagram-legend muted">
          Solid = spawn · dashed = inbound route · dotted = config / workspace files · bright edge = live subagent
          (current session)
        </p>
      </details>
      <details class="fleet-concepts__diagram" ?open=${props.diagramOpen ?? false}>
        <summary>Chat · Sessions · Agents · Channels · Subagents</summary>
        <pre
          class="fleet-concepts__ascii mono"
          aria-label="Fleet Control tab relationships ASCII diagram"
        >${FLEET_CONTROL_RELATIONSHIPS_ASCII}</pre>
        <p class="fleet-concepts__diagram-legend muted">
          Channels deliver inbound traffic; Agents are config; Sessions are transcript keys; Chat is where you run one
          session; Subagents are child sessions spawned from Chat.
        </p>
      </details>
      <dl class="fleet-concepts__list">
        ${FLEET_SYSTEM_CONCEPTS.map(
          (term) => html`
            <div class="fleet-concepts__term">
              <dt>${term.title}</dt>
              <dd>${term.definition}</dd>
            </div>
          `,
        )}
      </dl>
      ${
        props.onOpenGuide
          ? html`
              <button type="button" class="btn subtle fleet-concepts__guide-btn" @click=${props.onOpenGuide}>
                Open Fleet guide
              </button>
            `
          : nothing
      }
    </div>
  `;
}
